export const ImageMetadataModelModule = angular
    .module('app.services.model.models.imageMetadata', [])
    .value('imageMetadataModel', {
        imageLink: 'any',
        description: 'String',
        altText: 'String',
        title: 'String'
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/models/imageMetadata.model.js